import { render, staticRenderFns } from "./ModalWorkingHours.vue?vue&type=template&id=5afde5fd&scoped=true&"
import script from "./ModalWorkingHours.vue?vue&type=script&lang=js&"
export * from "./ModalWorkingHours.vue?vue&type=script&lang=js&"
import style0 from "./ModalWorkingHours.vue?vue&type=style&index=0&id=5afde5fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afde5fd",
  null
  
)

export default component.exports